/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Profile_Devices_DeleteInputs */

const es_user_profile_devices_delete = /** @type {(inputs: User_Profile_Devices_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Borrar Dispositivo`)
};

const en_user_profile_devices_delete = /** @type {(inputs: User_Profile_Devices_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete Device`)
};

/**
* | output |
* | --- |
* | "Delete Device" |
*
* @param {User_Profile_Devices_DeleteInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const user_profile_devices_delete = /** @type {((inputs?: User_Profile_Devices_DeleteInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Profile_Devices_DeleteInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_user_profile_devices_delete(inputs)
	return en_user_profile_devices_delete(inputs)
});
export { user_profile_devices_delete as "user.profile.devices.delete" }